import { useState } from "react";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-tagsinput components
import TagsInput from "react-tagsinput";
import "./style.css";

// Custom styles for SoftTagInput
import SoftTagInputRoot from "components/SoftTagInput/SoftTagInputRoot";

const SoftTagInput = ({
  size = "medium",
  error = false,
  success = false,
  onValidation,
  ref,
  ...rest
}) => {
  const [hasError, setHasError] = useState(false);

  // const handleInputChange = (tags) => {
  //   setHasError(tags.length === 0 && !rest.disabled);
  //   // You can perform additional validation here if needed
  // };

  const handleBlur = () => {
    setHasError(rest.value.length === 0 && !rest.disabled);
    // You can perform additional validation here if needed
  };
  return (
    <SoftTagInputRoot ownerState={{ size, error: hasError || error, success }}>
      <TagsInput
        {...rest}
        ref={ref}
        inputProps={{
          className: "react-tagsinput-input",
          placeholder: rest.placeholder || "Enter an Email",
          onBlur: rest.onBlur ? rest.onBlur : handleBlur
        }}
        tagProps={{ className: "react-tagsinput-tag", classNameRemove: "react-tagsinput-remove" }}
        onlyUnique={true}
      />
    </SoftTagInputRoot>
  );
};
// Typechecking props for the SoftTagInput
SoftTagInput.propTypes = {
  size: PropTypes.oneOf(["medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool,
  onValidation: PropTypes.func // Callback function for validation
};

export default SoftTagInput;
